import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-l', 'IconLetterL', [["path",{"d":"M7 4v16h10","key":"svg-0"}]]);